import React from 'react';

interface PageContainerProps {
  children: React.ReactNode;
  title?: React.ReactNode;
  noCard?: boolean;
}

const PageContainer: React.FC<PageContainerProps> = ({ children, title, noCard }) => {
  return (
    <div className="page-content" style={{ padding: 24 }}>
      {title ? (
        <div style={{ marginBottom: 16 }}>
          <span style={{ fontSize: '0.9rem', fontWeight: 600, color: '#374151' }}>{title}</span>
        </div>
      ) : null}
      {noCard ? children : <div className="card-container">{children}</div>}
    </div>
  );
};

export default PageContainer;
